import {
    FOOTER_DATA_REQUEST,
    FOOTER_DATA_REQUEST_SUCCESS,
    FOOTER_DATA_REQUEST_FAIL
} from './footerConstants'
export const footerSectionReducers = (state = {
    loading: true,
    error: '',
    address: '',
    phoneNumbers: '',
    workTime: '',
    shortAboutText: '',
}, action) => {
    switch (action.type) {
        case FOOTER_DATA_REQUEST:
            return { loading: true }
        case FOOTER_DATA_REQUEST_SUCCESS:
            return {
                loading: false,
                error: false,
                address: action.payload.address,
                phoneNumbers: action.payload.phoneNumbers,
                workTime: action.payload.workTime,
                shortAboutText: action.payload.shortAboutText,
            }
        case FOOTER_DATA_REQUEST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}